import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aea799ea&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=aea799ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea799ea",
  null
  
)

export default component.exports